import { FC } from "react";
import StandardModal from "./StandardModal";
import { FaDownload } from "react-icons/fa6";
import { useGetGuiaRedirecionamento, TipoGuia } from "hooks/groupPay/useGetGuiaRedirecionamento";

interface StandardModalCaixaEmailPayProps {
  showModal: boolean;
  onCloseModal: () => void;
}

const StandardModalCaixaEmailPay: FC<StandardModalCaixaEmailPayProps> = ({ showModal, onCloseModal }) => {
  const { mutate: getGuia } = useGetGuiaRedirecionamento();

  const handleSigaOsPassosClick = () => {
    getGuia({ tipoGuia: TipoGuia.REDIRECIONAMENTO_EMAIL_ADMINISTRADORA });
  };

  return (
    <StandardModal
      showModal={showModal}
      scrollable={false}
      onCloseModal={onCloseModal}
      videoSrc="https://www.youtube.com/watch?v=jApLoMi_jeQ"
      topBar="Como funciona o acesso à caixa de e-mail da administradora?"
      titulo="🔒 O que é o acesso à caixa de e-mail da administradora?"
      tituloStyle={{ fontSize: "1vw", fontWeight: "bold", color: "#2F4050", textAlign: "left" }}
      conteudoPrimario="Para que o Group Pay funcione corretamente, é necessário configurar o acesso à caixa de e-mail da sua administradora. Essa etapa consiste em preencher os dados necessários para permitir que nossa aplicação acesse essa caixa de forma segura e validada. Essas informações estão disponíveis na documentação do seu provedor de e-mail."
      conteudoPrimarioStyle={{ marginBottom: "0.85vh", fontSize: "0.85vw" }}
      conteudoSecundario={
        <>
          <p
            style={{
              fontSize: "0.85vw",
              lineHeight: "1.2",
              color: "#2F4050",
              fontWeight: "bold",
              marginBottom: "0.5vw",
            }}
          >
            🔧 Como funciona?
          </p>
          <p style={{ fontSize: "0.85vw", lineHeight: "1.2", color: "#2F4050", marginBottom: "0.5vw" }}>
            Após configurar o acesso, o Group Pay irá consultar automaticamente os e-mails recebidos na caixa da
            administradora, identificar as notas fiscais enviadas pelos fornecedores dos condomínios e trazê-las para
            dentro do sistema.
          </p>
          <p style={{ fontSize: "0.85vw", lineHeight: "1.2", color: "#2F4050", marginBottom: "0.5vw" }}>
            Você só precisará vincular cada nota a uma despesa existente ou cadastrar uma nova.
          </p>
          <p
            style={{ fontSize: "0.85vw", lineHeight: "1.2", color: "#2F4050", fontWeight: "bold", marginBottom: "1vw" }}
          >
            Assista ao vídeo acima para ver como configurar.
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "end",
              color: "#17a2b8",
              fontSize: "0.85vw",
              fontWeight: "bold",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={handleSigaOsPassosClick}
          >
            <span style={{ marginRight: "0.5vw", fontSize: "1vw" }}>
              <FaDownload />
            </span>
            Saiba como localizar o servidor IMAP
          </div>
        </>
      }
      size="lg"
      fecharModalAoClicarFora={true}
      containerStyle={{ margin: 0, paddingLeft: "1vw", textAlign: "left" }}
      footer={null}
    />
  );
};

export default StandardModalCaixaEmailPay;
